import type { IconSvgObject } from './types';

const ChevronDoubleCloseIcon: IconSvgObject = [
  ["path", { d: "M9 17L4.37165 12.8345C4.13508 12.6216 4 12.3183 4 12C4 11.6817 4.13508 11.3784 4.37164 11.1655L8.99995 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 7L19.6284 11.1655C19.865 11.3784 20 11.6817 20 12C20 12.3183 19.865 12.6216 19.6284 12.8345L15 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronDoubleCloseIcon;
